/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const mergeDeep = (...sources) => {
  // tool to check if item is object
  const isObject = (item) => {
    return (item && typeof item === 'object' && !Array.isArray(item));
  };

  // recursive merge routine
  const resursiveMerge = (target, ...sources) => {
    if (!sources.length) return target;
    const source = sources.shift();
  
    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          resursiveMerge(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }
  
    return resursiveMerge(target, ...sources);
  };

  // perform merge
  return resursiveMerge({}, ...sources);
};
